(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7404],{

/***/ 7404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ OpenJobsHighlight; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/SectionHeader.js
var SectionHeader = __webpack_require__(933);
// EXTERNAL MODULE: ./src/constants/durations.ts
var durations = __webpack_require__(4780);
// EXTERNAL MODULE: ./src/hooks/useQuery.ts + 1 modules
var useQuery = __webpack_require__(808);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../wif-ui-lib/dist/main.js
var main = __webpack_require__(128);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-c598cb52.mjs
var Button_c598cb52 = __webpack_require__(7977);
// EXTERNAL MODULE: ../wif-ui-lib/dist/JobList.js
var JobList = __webpack_require__(8132);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ./src/magnolia/components/OpenJobsHighlight/OpenJobsHighlight.module.scss
var OpenJobsHighlight_module = __webpack_require__(7241);
var OpenJobsHighlight_module_default = /*#__PURE__*/__webpack_require__.n(OpenJobsHighlight_module);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/helpers.ts


var openJobsHighlightId = "open-jobs-highlight";
function getStyleClassName() {
    for(var _len = arguments.length, suffixes = new Array(_len), _key = 0; _key < _len; _key++){
        suffixes[_key] = arguments[_key];
    }
    return (OpenJobsHighlight_module_default())[[
        openJobsHighlightId
    ].concat((0,_to_consumable_array/* default */.Z)(suffixes)).join("__")];
}
function generateOpenJobsPageLink(category) {
    var BASE_URL = "/open-jobs/";
    var searchParams = new URLSearchParams({
        category: category.id
    });
    return BASE_URL + "?" + searchParams.toString();
}

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/useJobsQuery.ts




var JOBS_COUNT_MOBILE = 3;
var JOBS_COUNT_TABLET_DESKTOP = 6;
function useJobsQuery(categoryId) {
    var searchParams = new URLSearchParams({
        offset: "0",
        limit: JOBS_COUNT_TABLET_DESKTOP.toString()
    });
    if (categoryId) searchParams.set("category", categoryId);
    var ref = (0,useQuery/* default */.Z)("/api/jobs/?" + searchParams.toString(), {
        disabled: !categoryId,
        cacheDurationInMs: durations/* ONE_MIN_IN_MS */.sW * 10
    }), result = ref.data, isLoading = ref.isLoading;
    var jobCardsCount = useJobCardsCount();
    if (isLoading || !(result === null || result === void 0 ? void 0 : result.jobs)) return Array(jobCardsCount).fill({
        isDataLoading: true
    });
    return ((result === null || result === void 0 ? void 0 : result.jobs) || []).slice(0, jobCardsCount).map(mapJobToJobCardProps);
}
function useJobCardsCount() {
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    return (0,react.useMemo)(function() {
        return viewport === "xs" || viewport === "sm" ? JOBS_COUNT_MOBILE : JOBS_COUNT_TABLET_DESKTOP;
    }, [
        viewport
    ]);
}
function mapJobToJobCardProps(job) {
    return {
        title: job.title,
        employerName: job.employer.name,
        location: job.employer.city,
        link: job.externalUrl,
        image: job.employer.imageUrl,
        expireDate: job.expireDate,
        isDataLoading: false
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/useCurrentCategory.ts



function useCurrentCategory() {
    var categories = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], isHovering = arguments.length > 1 ? arguments[1] : void 0;
    var MAX_INDEX = categories.length;
    var ref = (0,react.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react.useState)(0), index = ref1[0], setIndex = ref1[1];
    var isWindowVisible = useIsWindowVisible();
    var isIntervalDisabled = categories.length === 0 || !isWindowVisible || !!isHovering;
    (0,main/* useInterval */.Yz)(function() {
        return startTransition(function() {
            setIndex(function(i) {
                return (i + 1) % MAX_INDEX;
            });
        });
    }, 8 * durations/* ONE_SEC_IN_MS */.mW, {
        disabled: isIntervalDisabled
    });
    return (0,react.useMemo)(function() {
        return categories[index];
    }, [
        categories,
        index
    ]);
}
function useIsWindowVisible() {
    return (0,react.useSyncExternalStore)(subscribeToVisibilityChange, getWindowVisibilitySnapshot, function() {
        return false;
    });
}
function subscribeToVisibilityChange(listener) {
    window.document.addEventListener("visibilitychange", listener);
    return function() {
        return window.document.removeEventListener("visibilitychange", listener);
    };
}
function getWindowVisibilitySnapshot() {
    return window.document.visibilityState === "visible";
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/LatestOpenings.tsx







function LatestOpenings(param) {
    var title = param.title, _categories = param.categories, categories = _categories === void 0 ? [] : _categories, seeMoreButtonText = param.seeMoreButtonText;
    var ref = (0,main/* useElementHover */.N4)(), ref1 = ref.ref, isHovering = ref.isHovering;
    var currentCategory = useCurrentCategory(categories, isHovering);
    var jobs = useJobsQuery(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id);
    if (!currentCategory) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block_9b78bd10.B.Content, {
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getStyleClassName("latest-openings"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "texts__component_title--bold",
                    children: [
                        currentCategory.name,
                        " – ",
                        title
                    ]
                })
            }),
            jobs.map(function(card, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobList/* JobCard */.th, (0,_object_spread/* default */.Z)({}, card), index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getStyleClassName("latest-openings", "see-more"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_479ac100.L, {
                    href: generateOpenJobsPageLink(currentCategory),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_c598cb52.B.Primary, {
                        text: seeMoreButtonText,
                        asDiv: true
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../wif-ui-lib/dist/Chips-2709174d.mjs
var Chips_2709174d = __webpack_require__(7759);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/PopularCategories.tsx



function PopularCategories(param) {
    var title = param.title, _categories = param.categories, categories = _categories === void 0 ? [] : _categories;
    if (categories.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B.Content, {
        className: getStyleClassName("content"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: getStyleClassName("popular-categories"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "texts__component_title--bold",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: getStyleClassName("popular-categories", "chips"),
                    children: categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips_2709174d.C, {
                            text: category.name,
                            href: generateOpenJobsPageLink(category)
                        }, category.id);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/OpenJobsHighlight.tsx








function OpenJobsHighlight(props) {
    var _heading = props.heading, heading = _heading === void 0 ? "Open jobs" : _heading, _subHeading = props.subHeading, subHeading = _subHeading === void 0 ? "English speaking jobs across Finland" : _subHeading, _categoriesTitle = props.categoriesTitle, categoriesTitle = _categoriesTitle === void 0 ? "Most popular job categories" : _categoriesTitle, _openingsTitle = props.openingsTitle, openingsTitle = _openingsTitle === void 0 ? "Latest openings" : _openingsTitle, _seeMoreButtonText = props.seeMoreButtonText, seeMoreButtonText = _seeMoreButtonText === void 0 ? "See more" : _seeMoreButtonText, _totalJobs = props.totalJobs, totalJobs = _totalJobs === void 0 ? 0 : _totalJobs, _categories = props.categories, categories = _categories === void 0 ? [] : _categories;
    // Revalidating data
    var data = (0,useQuery/* default */.Z)("/api/jobs/status/", {
        cacheDurationInMs: durations/* ONE_MIN_IN_MS */.sW * 10,
        initialData: {
            totalJobs: totalJobs,
            categories: categories
        }
    }).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: openJobsHighlightId,
        "data-testid": openJobsHighlightId,
        className: getStyleClassName(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* SectionHeader */.M, {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block_9b78bd10.B, {
                topPadding: Block_9b78bd10.B.Padding.NONE,
                bottomPadding: Block_9b78bd10.B.Padding.SMALL,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B.Content, {
                        className: getStyleClassName("content"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                gridColumn: "1/-1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: getStyleClassName("total-count"),
                                    children: data.totalJobs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "heading__section",
                                    children: subHeading
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularCategories, {
                        title: categoriesTitle,
                        categories: data.categories
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestOpenings, {
                        title: openingsTitle,
                        categories: data.categories,
                        seeMoreButtonText: seeMoreButtonText
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 7241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"open-jobs-highlight":"OpenJobsHighlight_open-jobs-highlight__D2j2y","open-jobs-highlight__content":"OpenJobsHighlight_open-jobs-highlight__content__jw0ct","open-jobs-highlight__total-count":"OpenJobsHighlight_open-jobs-highlight__total-count__liBj3","open-jobs-highlight__popular-categories":"OpenJobsHighlight_open-jobs-highlight__popular-categories__Gu2qi","open-jobs-highlight__popular-categories__chips":"OpenJobsHighlight_open-jobs-highlight__popular-categories__chips__kX8W0","open-jobs-highlight__latest-openings":"OpenJobsHighlight_open-jobs-highlight__latest-openings__c8_8W","open-jobs-highlight__latest-openings__see-more":"OpenJobsHighlight_open-jobs-highlight__latest-openings__see-more__jeKat"};

/***/ }),

/***/ 7759:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3355);




const b = "chips", k = "chips--compact", E = "chips--bolder", I = "close-icon", o = {
  chips: b,
  chipsCompact: k,
  chipsBolder: E,
  closeIcon: I
}, i = 40;
function _(e) {
  const {
    text: c = "",
    variant: l = "standard",
    bolder: r = !1,
    clipLongText: h = !0,
    selected: s,
    showXWhenSelected: m = !1
  } = e, p = c.length > i, n = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, p && h ? `${c.slice(0, i).trim()}...` : c, m && s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__.W.CLOSE, className: o.closeIcon })), a = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    e.className,
    r ? o.chipsBolder : _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyText,
    o.chips,
    l === "compact" && o.chipsCompact
  );
  return e.as === "button" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: a,
      onClick: e.onClick,
      "aria-checked": !!s,
      role: "checkbox",
      title: c
    },
    n
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      title: c,
      href: e.href || "#",
      disableLinkTextStyle: !0,
      "aria-checked": !!s,
      role: "checkbox",
      className: a
    },
    n
  );
}

//# sourceMappingURL=Chips-2709174d.mjs.map


/***/ })

}]);